import { Injectable } from '@angular/core';
import Ajv from 'ajv';
import addFormats from 'ajv-formats';

@Injectable({
  providedIn: 'root'
})
export class JsonValidationService {
  private ajv = new Ajv({ allErrors: true });
  private validateFn;

  constructor() {
    addFormats(this.ajv);
    this.registerCustomKeywords();
  }

  private registerCustomKeywords(): void {
    // qt-uri-protocols keyword
    this.ajv.addKeyword({ keyword: 'qt-uri-protocols', type: 'string', schemaType: 'array', validate: () => true});
    // validateDefaultRange keyword
    this.ajv.addKeyword({ keyword: 'validateDefaultRange', type: 'object', schemaType: 'boolean', errors: true,
      validate: function validateDefaultRange( schema: boolean, data: any, dataCxt: any) {
        if (!schema) return true;
        const { minimum, maximum, default: defValue } = data;
        // skip validation if default is undefined
        if (defValue === undefined) return true;

        const defNum = Number(defValue);
        const minNum = minimum ? Number(minimum) : undefined;
        const maxNum = maximum ? Number(maximum) : undefined;
        const errors = [];
        let message = '';
        const isBelowMin = minNum && defNum < minNum;
        const isAboveMax = maxNum && defNum > maxNum;

        if (isBelowMin && isAboveMax) {
          message = `default value (${defNum}) must be between minimum (${minNum}) and maximum (${maxNum})`;
          errors.push({ instancePath: dataCxt.instancePath, keyword: 'validateDefaultRange',message});
        } else if (isBelowMin) {
          message = `default value (${defNum}) must be greater than or equal to minimum (${minNum})`;
          errors.push({ instancePath: dataCxt.instancePath, keyword: 'validateDefaultRange', message});
        } else if (isAboveMax) {
          message = `default value (${defNum}) must be less than or equal to maximum (${maxNum})`;
          errors.push({ instancePath: dataCxt.instancePath, keyword: 'validateDefaultRange', message});
        }

        if (errors.length > 0) {
          // Attach custom errors to the function so AJV reports them
          (validateDefaultRange as any).errors = errors; 
          return false;
        }
        return true;
      }
    });
  }

  validate(data: any,schema?: object): { valid: boolean; errors?: any } {
    this.validateFn = this.ajv.compile(schema);
    const valid = this.validateFn(data);
    return {
      valid,
      errors: this.validateFn.errors
    };
  }
  
}